import dynamic from 'next/dynamic';

const SanityVisualEditingBridge = dynamic(
  () => import('#/components/SanityVisualEditingBridge'),
  { ssr: false },
);

export default function SanityVisualEditing({
  enabled,
}: {
  enabled?: boolean;
}) {
  if (!enabled) return null;

  return <SanityVisualEditingBridge />;
}
